<template>
  <div id="app">
    <nav-bar></nav-bar>
    <div class="container" v-loading="!user">
      
      <div class="row">
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              Chats
            </div>
            <list-chats/>
          </div>
        </div>
        <div class="col-md-8">
          <actual-chat></actual-chat>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NavBar from './components/navbar'
import ListChats from './components/list_chats'
import ActualChat from './components/chat_actual'
import { mapState,mapActions } from 'vuex'
export default {
  components: {
    NavBar,
    ListChats,
    ActualChat
  },
  computed: {
    ...mapState({
      user: (state) => state.Chat.user,
    })
  },
  created() {
    this.get_user()
  },
  methods: {
    ...mapActions({
      get_user: 'Chat/get_user'
    })
  }
}
</script>
